import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpRightFromSquare, faAnglesDown, faAnglesUp} from "@fortawesome/free-solid-svg-icons";
import {PROGRAM_LIST} from "../config/program";
import watanabeImg from "../images/lecturer02.webp";
import emotoImg from "../images/lecturer03.webp";
// import nipImg from "../images/lecturer05.webp";
import hunasakiImg from "../images/lecturer04.webp";
import kodamaImg from "../images/lecturer07.webp";
import {useState} from "react";

export const Program = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleBiography = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index], // クリックしたindexの状態を反転させる
    }));
  };

  return (
    <section id="program">
      <h3>
        プログラム<span>セミナー当日、雷関連製品展示コーナーもご覧いただけます。</span>
      </h3>
      {PROGRAM_LIST.map((program, index) => {
        // 各ループの中で、この項目が開いているかを判定する変数を定義
        const isOpen = !!openItems[index];

        return (
          <div className="programWrap" key={index}>
            <h4 className="programTime">
              {program.lecture}
              <span>{program.time}</span>
            </h4>
            <h4 className="programTitle">{program.title}</h4>

            <div className="programDetailWrap">
              <div>
                <p className="speaker">
                  {program.speaker}{" "}
                  <span>
                    {program.speaker === "吉田 厚" ||
                    program.speaker === "NIPエンジニアリング株式会社" ||
                    program.speaker === "早川 信一" ||
                    program.speaker === ""
                      ? ""
                      : `氏`}
                  </span>
                </p>
                <p className="company" dangerouslySetInnerHTML={{__html: program.company}}></p>
                <p className="overview">{program.overview}</p>
              </div>
              {/* 指定したindexの時だけ画像を表示 */}
              {index === 1 && <img src={watanabeImg} alt="渡辺秀明氏の写真" />}
              {index === 2 && <img src={emotoImg} alt="榎戸輝揚氏の写真" />}
              {index === 4 && <img src={hunasakiImg} alt="舟崎博志氏の写真" />}
              {index === 5 && <img src={kodamaImg} alt="小玉鉄晃氏の写真" />}
            </div>

            {program.lecture !== "休憩" && (
              <>
                {program.speaker === "吉田 厚" ? null : program.speaker === "舟崎 博志" ? (
                  <a
                    href="https://www.nip-eng.co.jp/company/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="biographyBtn">
                    <strong>会社概要</strong>を見る
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                  </a>
                ) : program.speaker === "小玉 鉄晃" ? (
                  <a
                    href="https://www.otowadenki.co.jp/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="biographyBtn">
                    <strong>会社概要</strong>を見る
                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                  </a>
                ) : (
                  <p className="biographyBtn" onClick={() => toggleBiography(index)} style={{cursor: "pointer"}}>
                    <strong>略歴</strong>を見る
                    <FontAwesomeIcon icon={isOpen ? faAnglesUp : faAnglesDown} />
                  </p>
                )}

                {program.speaker !== "舟崎 博志" && (
                  <div
                    className={`biography ${isOpen ? "is-open" : "is-closed"}`}
                    dangerouslySetInnerHTML={{__html: program.biography}}></div>
                )}
              </>
            )}
          </div>
        );
      })}
    </section>
  );
};
